// AnsweredByOtherAnswer

import React, { useState } from "react";
import { handlePauseAllVideo, removeStylesFromHtml } from "../../utils";
import { ReactComponent as ArrowUpIcon } from "../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../Icons/arrowDown.svg";
import { ReactComponent as RFUIcon } from "../../Icons/rfuIcon.svg";
import { ReactComponent as VerifyIcon } from "../../Icons/verify.svg";
import { ReactComponent as CopyIcon } from "../../Icons/copy.svg";
import { ReactComponent as ShareIcon } from "../../Icons/share.svg";
import Voting from "../Voting/Voting";
import Button2 from "../Button2/Button2";
import { useDispatch, useSelector } from "react-redux";
import { requestForUpdate } from "../../API/api";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import ImgCarousal from "../Carousal/carousal";
import Button from "../Button/Button";
import { CURRENT_ROLE } from "../../API/url";
import { message } from "antd";
import { ColorLens } from "@mui/icons-material";
import Rating from "../Rating/Rating";

const contentStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  width: '100%'
};
export default function AnsweredByOtherAnswer({ data }) {
  // console.log(data.attachmentURL,'hi')
  const ratingState = useSelector((state) => state.domain);
  const [messageApi, contextHolder] = message.useMessage();
  const [isStapled, setIsStapled] = useState(false);
  const randomNumber = Math.random() * 10;
  const editorState = useSelector(state => state.editor);
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, getSelectedQuestion, getSelectedAnswer } = bindActionCreators(Actions, dispatch)
  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };


  // const onClickStapleAnswer = (str) => {
  //   setIsStapled(true);

  //   setTx(str.answerCopy)
  //   if(currentRoute.pathname.includes('editor')){
  //     let newStr = editorState.answerText.concat(str.answerText);
  //     updateAnswerTextForEditor(newStr)
  //   }else{
  //     props.onchangeVal(str);
  //   }
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // }
  const userState = useSelector((state) => state.user);
  const [permission, setPermission] = useState(userState.roles.find(data => data.roleName === CURRENT_ROLE).permissions.find(item => item.id === 9));
  const searchState = useSelector((state) => state.search);
  const [isAccept, setAccept] = useState(null);
  const [isPlay, setPlay] = useState(false);
  const [isShow, setShow] = useState(false);
  const trimString = (str) => {
    if (str?.length > 350) {
      return str?.slice(0, 350) + "...";
    }
    return str;
  };
  const ansStyles = {
    marginTop: "10px",
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "300",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const showMoreStyles = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "500",
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };

  const onClickButton = (key) => {
    // console.log("");
  };

  // const onClickRFU = () => {
  //   advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
  //   getSelectedAnswer(data);
  //   getSelectedQuestion(question);
  // };
  const stripHtml = (htmlString) => {
    return htmlString
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n")
      .replace(/<\/?[^>]+(>|$)/g, "");
  }
  const success = () => {
    messageApi.info("hl");
  };
  // const onClickCopy=(text)=>{
  //   toast.success(successfulHelpful("Text copied!"), {
  //     position: toast.POSITION.TOP_RIGHT,
  //   });
  //     let newString = stripHtml(data.answerText);
  //     navigator.clipboard.writeText(`${question.question}\n\n${newString}`);

  // }
  const onClickPlayPause = () => {
    setPlay(!isPlay);
    // if(isPlay){
    //   document.getElementById(`${question.questionUuid}_${randomNumber}`).pause();
    // }else{
    //   document.getElementById(`${question.questionUuid}_${randomNumber}`).play();
    // }
  }

// console.log("data",data.attachments[0])
  return (
    <>

      {data.attachments && data.attachments.length > 0 && (data.attachments[0].name.toLowerCase().includes('.mp4') || data.attachments[0].name.toLowerCase().includes('.mov')) && (
        <>
          <div className="mt-1" style={{ textAlign: 'right' }}><Button type={'primary'} text={isPlay ? 'Hide Video' : 'Show Video'} onClickFunc={onClickPlayPause} /></div>
          {isPlay && <div className="mb-4 mt-3" style={{ textAlign: 'center' }}>
            <div style={{ width: '100%' }}>
              <video
                id={`${data.questionUuid}_${randomNumber}`}
                controls
                onBlur={() => handlePauseAllVideo()}
                style={contentStyle}
              >
                <source
                  src={`${data.attachments[0].objectUrl}#t=${data.startTime},${data.endTime}`}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          }
        </>
      )}
      {data.attachmentURL && data.attachmentURL.length > 0 && (
        <div className="mb-4 mt-3">
          <div>
            <ImgCarousal data={data.attachmentURL} />
          </div>
        </div>
      )}
      <div
        style={ansStyles}
        dangerouslySetInnerHTML={{
          __html: !isShow
            ? removeStylesFromHtml(
              trimString(
                data.answer === null
                  ? data.contextData
                  : data.answer
              )
            )
            : removeStylesFromHtml(
              data.answer === null
                ? data.contextData
                : data.answer
            ),
        }}
      ></div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <div>
          {data.answer !== null
            ? data.answer.length > 350 &&
            !isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show more&nbsp;
                <ArrowDownIcon />
              </div>
            )
            : data.answer.length > 350 &&
            !isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show more&nbsp;
                <ArrowDownIcon />
              </div>
            )}
          {data.answer !== null
            ? data.answer.length > 350 &&
            isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show less&nbsp;
                <ArrowUpIcon />
              </div>
            )
            : data.answer.length > 350 &&
            isShow && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                Show less&nbsp;
                <ArrowUpIcon />
              </div>
            )}
        </div>

        {/* {question.docType === "expertqa" && (answerCopy
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button2 type={"light"} onClickFunc={onClickCopy}>
              <CopyIcon />
            </Button2>
            &nbsp;
            <Button2 type={"light"} onClickFunc={onClickShareButton}>
              <ShareIcon />
            </Button2>
            {permission !== undefined && !data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      (data.curationCategory !== 1 ||
                        data.curationStatus !== "pending") &&<>
              &nbsp;
            <Button2 type={"dark"} onClickFunc={onClickRFU}>
              <RFUIcon />
              &nbsp;Request for update
            </Button2>


            </>}
            {permission !== undefined && !data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      data.curationCategory === 1 &&
                        data.curationStatus === "pending" &&<>
              &nbsp;
            <Button2 type={"dark"} onClickFunc={onClickRFU}>
              <RFUIcon />
              &nbsp;Request for update
            </Button2>
            </>}
            &nbsp;
            <Button2 onClickFunc={onClickButton}>
              <Voting value={data.isHelpful===true?1:data.isReject===true?0:null} onClickFunc={onClickVote} />
            </Button2>
          </div>
        )} */}
        {/* {question.docType !== "expertqa" && question.docType !== "Email" && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button2 type={"light"} onClickFunc={onClickCopy} >
              <CopyIcon  />
            </Button2>
            &nbsp;
            <Button2 type={"dark"}>
              <VerifyIcon />
              &nbsp;Verify
            </Button2>
            &nbsp;
            <Button2 onClickFunc={onClickButton}>
              <Voting value={isAccept} onClickFunc={onClickVote} />
            </Button2>
          </div>
        )} */}
        {/* {
         ratingState?.ratings &&
         ratingState.ratings[data?.originalAnswerUuid===null?data.answerUuid:data.originalAnswerUuid] !== null && !editorState.ratingBool&&
           <div style={{ display: "flex", alignItems: "center" }}>
                   
                  
                   <Button2 onClickFunc={()=>console.log("clicked")}>
                <Rating id={data?.originalAnswerUuid===null?data.answerUuid:data.originalAnswerUuid} />
                 
                   </Button2>
                 </div>
          
       
        } */}
        {
          ratingState?.ratings &&
          ratingState.ratings[data?.originalAnswerUuid ?? data.answerUuid] !== null &&
          !editorState.ratingBool && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button2 onClickFunc={() => console.log("clicked")}>
                <Rating id={data?.originalAnswerUuid ?? data.answerUuid} />
              </Button2>
            </div>
          )
        }
      </div>

    </>
  );
}
